import { useTranslation } from 'react-i18next';

export default function StatsBanner() {
  const { t } = useTranslation();

  const stats = [
    { icon: 'ri-film-line', value: '10,000+', label: t('home:statTitles') },
    { icon: 'ri-tv-2-line', value: '5,000+', label: t('home:statSeries') },
    { icon: 'ri-refresh-line', value: '50+', label: t('home:statUpdate') },
  ];

  return (
    <section className="py-8 bg-primary-500">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-3 gap-4">
          {stats.map((stat, idx) => (
            <div key={idx} className="text-center">
              <div className="w-12 h-12 mx-auto mb-2 flex items-center justify-center bg-white/20 rounded-full">
                <i className={`${stat.icon} text-xl text-white`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-bold text-white mb-1">{stat.value}</div>
              <div className="text-xs md:text-sm text-white/70">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}